/**
 * Ассеты косметики Straddle Pass: `pass_items.asset` из БД → URL бандла.
 * Файлы лежат в assets/pass/** (копия пакета косметики хэндоффа); Vite
 * отдаёт их как URL (lazy — в основной чанк ничего не инлайнится).
 */

const files = import.meta.glob('../../assets/pass/**/*.{lottie,webp,svg}', {
  query: '?url',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const byAsset = new Map<string, string>();
for (const [path, url] of Object.entries(files)) {
  // '../../assets/pass/frames/frame_steel.lottie' → 'frames/frame_steel.lottie'
  const rel = path.split('/assets/pass/')[1];
  if (rel) byAsset.set(rel, url);
}

/** URL ассета по значению pass_items.asset; null для css-предметов. */
export function assetUrl(asset: string | null | undefined): string | null {
  if (!asset) return null;
  return byAsset.get(asset) ?? null;
}

/** Цвета шкалы редкости C (README «Шкала редкости»). */
export const RARITY_COLOR = ['#7F848C', '#5B7196', '#7C6B99', '#C8A04E'] as const;
export const RARITY_TEXT_DARK = ['#B4B9C2', '#9FB4D8', '#B8A7D6', '#D9B464'] as const;
export const RARITY_TEXT_LIGHT = ['#5F646C', '#3F5473', '#5C4C78', '#B0883C'] as const;
export const RARITY_LABEL = ['Обычная', 'Редкая', 'Эпическая', 'Легендарная'] as const;
/** Мужской род — для предметов («Эпический предмет», бейджи 6.5b/6.7). */
export const RARITY_LABEL_M = ['Обычный', 'Редкий', 'Эпический', 'Легендарный'] as const;
export const SLOT_LABEL: Record<string, string> = {
  frame: 'Рамка',
  nick: 'Ник',
  row: 'Строка',
  bg: 'Фон',
};

/** Текст цветом редкости с учётом темы: className="rtx" + этот style. */
export function rarityTextStyle(rarity: number): Record<string, string> {
  return {
    '--rtx-d': RARITY_TEXT_DARK[rarity] ?? RARITY_TEXT_DARK[0],
    '--rtx-l': RARITY_TEXT_LIGHT[rarity] ?? RARITY_TEXT_LIGHT[0],
  };
}

/** Альфы по ступеням (макет «компоненты»): заливка-tint и обводка. */
export const RARITY_TINT_A = [0.14, 0.14, 0.15, 0.16] as const;
export const RARITY_BD_A = [0.45, 0.5, 0.55, 0.6] as const;

export function rarityTint(rarity: number, alpha: number): string {
  const hex = RARITY_COLOR[rarity] ?? RARITY_COLOR[0];
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
